var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 39,
    viewBox: "0 0 41 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8646 3.15162C18.0941 -0.110282 22.9059 -0.110269 25.1353 3.15163L26.0171 4.44185C31.542 12.5253 36.2888 21.1138 40.1939 30.0923L40.3781 30.5158C41.7543 33.6799 39.6752 37.2727 36.2461 37.6559C25.7813 38.8255 15.2187 38.8255 4.75385 37.6559C1.32478 37.2727 -0.754376 33.6799 0.62182 30.5158L0.806008 30.0923C4.71116 21.1138 9.45796 12.5252 14.9828 4.44184L15.8646 3.15162ZM22.5417 13.375C22.5417 14.5026 21.6276 15.4167 20.5 15.4167C19.3724 15.4167 18.4583 14.5026 18.4583 13.375C18.4583 12.2474 19.3724 11.3333 20.5 11.3333C21.6276 11.3333 22.5417 12.2474 22.5417 13.375ZM20.5 18.9896C21.3457 18.9896 22.0313 19.6751 22.0313 20.5208V30.7292C22.0313 31.5749 21.3457 32.2604 20.5 32.2604C19.6543 32.2604 18.9688 31.5749 18.9688 30.7292V20.5208C18.9688 19.6751 19.6543 18.9896 20.5 18.9896Z",
    fill: "#DF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.a8435ea2c4a09c717a37c29d7c85461b.svg";
export { ForwardRef as ReactComponent };